import "./Contact.module.css";
import MainNavigation from "@/reusable_sections/Header";
import LetsBuildTheFuture from "./sections/LetsBuildTheFuture";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <MainNavigation />
      <LetsBuildTheFuture />
      <Footer />
    </div>;
}